// Event, Dialog 

// Api 

// Constant 
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRatingService from '@/scripts/rating/baseRatingService';

export default {

    extends: baseRatingService,

    data() {

        return {
            isShowDetails: false,
            level: 0,
            note: null,
            suggestionList: [],

            description1: null,
            description2: null,
        };
    },

    props: {
        targetSession: {
            type: Object,
            default: null,
        },
    },

    watch: {
        targetSession: function (newVal, oldVal) {
            this.level = 0;
            this.note = null;
            this.suggestionList = [];
        },

        level: function (newVal, oldVal) {
            switch (newVal) {
                case 1:
                case 2:
                case 3:
                    let value1 = Math.floor(Math.random() * 4) + 1;
                    switch (value1) {
                        case 1:
                            this.description1 = 'Have you had any trouble?';
                            this.description2 = 'Please share with us on our 24/7 live chat to get support.';
                            break;

                        case 2:
                            this.description1 = 'We are so sorry for the inconvenience.';
                            this.description2 = 'Please let us know how we can help you.';
                            break;

                        case 3:
                            this.description1 = 'We are sorry for your unsatisfactory experience.';
                            this.description2 = 'Please give us more details to improve our service.';
                            break;

                        case 4:
                            this.description1 = 'It seems you are having problems using our service.';
                            this.description2 = "Don't forget we have 24 / 7 live chat to support you.";
                            break;

                        default:
                            break;
                    }
                    break;

                case 4:
                case 5:
                    let value2 = Math.floor(Math.random() * 4) + 1;
                    switch (value2) {
                        case 1:
                            this.description1 = 'We are happy that you had a good experience using the service.';
                            this.description2 = "Don't hesitate to share your thoughts with us.";
                            break;

                        case 2:
                            this.description1 = 'Looks like you had a good session.';
                            this.description2 = "That's great!";
                            break;

                        case 3:
                            this.description1 = 'If you had a great experience, please support us by recommending us to your friends :D';
                            this.description2 = null;
                            break;

                        case 4:
                            this.description1 = "It’s wonderful to hear that you found this session productive.";
                            this.description2 = "See you again in the next happy sessions!";
                            break;

                        default:
                            break;
                    }
                    break;

                default:
                    break;
            }
        },
    },

    methods: {

        // Close this pop-up
        closeThisPopup(isUserClicked = true) {
            this.closePopup(POPUP_ID.RATE_IMAGE);
            if (isUserClicked) {
                this.matomoLog('ItemImage_Vote', 'Click', 'Close vote');
            }
        },

        // Get suggestion list
        getSuggestionList(value) {
            this.suggestionList = JSON.parse(JSON.stringify(this.$CommonParameter.rating[value - 1].slice()))
        },

        // Select item
        selectItem(item) {
            let newArray = this.suggestionList.slice();
            let currentItem = newArray.find(x => x.id === item.id);
            let selected = currentItem.selected;
            currentItem.selected = !selected;
            this.suggestionList = newArray;
        },

        //#region Submit 
        submit() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    type: 1,
                    level: this.level,
                    note: this.note,
                    suggestionList: this.suggestionList.length > 0 ? this.suggestionList.filter(x => x.selected).map(x => x.value) : [],
                    billingCode: this.targetSession.billingCode,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.ratingSubmit(
                    data,
                    () => {
                        this.closeThisPopup(false);
                        this.matomoLog('ItemImage_Vote', 'Click', 'Star vote', this.level);
                        this.matomoLog('ItemImage_Vote', 'Click', 'Comment', this.note);
                        this.matomoLog('ItemImage_Vote', 'Click', 'Submit vote');
                    }
                )
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}